export const DOC_SYNC_FROM_VIN_REQUEST = 'DOC_SYNC_FROM_VIN_REQUEST';
export const DOC_SYNC_FROM_VIN_SUCCESS = 'DOC_SYNC_FROM_VIN_SUCCESS';
export const DOC_SYNC_FROM_VIN_FAILURE = 'DOC_SYNC_FROM_VIN_FAILURE';
